const color = [
  "primary",
  "status-green",
  "status-red",
  "status-yellow",
  "status-orange",
  "status-gray",
  "status-blue",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

const size = [
  "3xs",
  "2xs",
  "xs",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl",
  "3xl"
] as const

export default {
  "slots": {
    "root": "inline-flex items-center justify-center shrink-0 select-none rounded-full align-middle",
    "image": "h-full w-full rounded-[inherit] object-cover",
    "fallback": "font-medium truncate",
    "icon": "shrink-0"
  },
  "variants": {
    "color": {
      "primary": {
        "root": "bg-primary/10",
        "fallback": "text-primary",
        "icon": "text-primary"
      },
      "status-green": {
        "root": "bg-status-green/10",
        "fallback": "text-status-green",
        "icon": "text-status-green"
      },
      "status-red": {
        "root": "bg-status-red/10",
        "fallback": "text-status-red",
        "icon": "text-status-red"
      },
      "status-yellow": {
        "root": "bg-status-yellow/10",
        "fallback": "text-status-yellow",
        "icon": "text-status-yellow"
      },
      "status-orange": {
        "root": "bg-status-orange/10",
        "fallback": "text-status-orange",
        "icon": "text-status-orange"
      },
      "status-gray": {
        "root": "bg-status-gray/10",
        "fallback": "text-status-gray",
        "icon": "text-status-gray"
      },
      "status-blue": {
        "root": "bg-status-blue/10",
        "fallback": "text-status-blue",
        "icon": "text-status-blue"
      },
      "secondary": {
        "root": "bg-secondary/10",
        "fallback": "text-secondary",
        "icon": "text-secondary"
      },
      "success": {
        "root": "bg-success/10",
        "fallback": "text-success",
        "icon": "text-success"
      },
      "info": {
        "root": "bg-info/10",
        "fallback": "text-info",
        "icon": "text-info"
      },
      "warning": {
        "root": "bg-warning/10",
        "fallback": "text-warning",
        "icon": "text-warning"
      },
      "error": {
        "root": "bg-error/10",
        "fallback": "text-error",
        "icon": "text-error"
      },
      "neutral": {
        "root": "bg-elevated",
        "fallback": "text-muted",
        "icon": "text-muted"
      }
    },
    "size": {
      "3xs": {
        "root": "size-4 text-[8px]"
      },
      "2xs": {
        "root": "size-5 text-[10px]"
      },
      "xs": {
        "root": "size-6 text-xs"
      },
      "sm": {
        "root": "size-7 text-sm"
      },
      "md": {
        "root": "size-8 text-base"
      },
      "lg": {
        "root": "size-9 text-lg"
      },
      "xl": {
        "root": "size-10 text-xl"
      },
      "2xl": {
        "root": "size-11 text-[22px]"
      },
      "3xl": {
        "root": "size-12 text-2xl"
      }
    }
  },
  "defaultVariants": {
    "size": "md" as typeof size[number],
    "color": "neutral" as typeof color[number]
  }
}